import { IStateInfo } from '../../../../components/FindUSSpecies/helpers/buildStateDataSpecies';
import { PreFooterLinks } from '../../../../components/PreFooterLinks/PreFooterLinks';
import { getRegionUrl, getSpeciesUrl } from '../../../../helpers/urls';
import { GetBasicSpeciesInfoFromList_species_edges_node } from '../../../../interfaces/graphql';
import { SUB_LINK_IDS } from '../../helpers/speciesHelpers';

interface IProps {
  speciesName: string;
  speciesStatesList: IStateInfo[];
  popularSpecies: GetBasicSpeciesInfoFromList_species_edges_node[];
}

export const PreFooterLinksSection = ({
  speciesName,
  speciesStatesList,
  popularSpecies,
}: IProps) => {
  const topStatesUS = speciesStatesList.map(state => ({
    id: state.State_Id,
    name: state.State,
    url: getRegionUrl('US', state.State_Id, state.State, 'United States'),
  }));

  const popularSpeciesList = popularSpecies.map(species => ({
    id: species._id,
    name: species.displayName,
    url: getSpeciesUrl(species._id, species.displayName),
  }));

  if (topStatesUS.length === 0 && popularSpeciesList.length === 0) {
    return null;
  }

  const linkList = [
    {
      linkList: topStatesUS,
      headingText: `States for catching ${speciesName} in the US`,
    },
    {
      linkList: popularSpeciesList,
      headingText: `Most popular species`,
    },
  ];

  return <PreFooterLinks id={SUB_LINK_IDS.EXPLORE_MORE} linkLists={linkList} />;
};
